import React, { Component, isValidElement } from "react";
import TableList from "./CustomTool/TableList";
import { Edit, Delete, LogoDevOutlined } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { withRouter } from "../HOC/withRouter";
import { apiURL, fetchReciept } from "./API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  applyTrimOnObjectValues,
  getRowColData,
  get_YMD_from_SYS,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";
import { Grid } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";

class InvoiceListTable extends Component {
  state = {
    PendingInvoiceList: [],
    LedgerGroup: [],
    LedgerGroupList: [],
    defaultSetting: {},
    DefaultEntrySettingList: [],
    PaymentData: [],
    dec_amount: "",
    columns: [
      // { id: "Action", label: "Search", name: "Search" },
      {
        id: "chk_paymentmode",
        label: "",
        type: "Chk",
        // defValue: 0,
        CtrlProps: {
          disablecondition: [
            {
              colID: "enablestatus",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      // { id: "vac_ledgername", label: "Payment Mode Ledger" },
      { id: "bint_salesacyear", label: "Invoice Year" },
      { id: "vac_invoiceno", label: "Invoice No" },
      { id: "dec_oustandingamount", label: "Outstanding Amount" },
      {
        id: "dec_amount",
        label: "Paid Amount",
        type: "CtTxtAmt",
        // defValue: 0,
        CtrlProps: {
          defValue: "",
          width: 100,
          maxLength: 10,
          disablecondition: [
            {
              colID: "enablestatus",
              value: false,
              relationalOperator: "===",
            },
          ],
        },
      },
      //   {
      //     id: "vac_chequeno",
      //     label: "Cheque No",
      //     type: "CtTxtNum",
      //     CtrlProps: { value: "", width: 100, maxLength: 6 },
      //   },
      //   {
      //     id: "vac_referenceno",
      //     label: "Reference No",
      //     type: "CtTxtNum",
      //     CtrlProps: { value: "", width: 100, maxLength: 100 },
      //   },
      //   {
      //     id: "dat_transactiondate",
      //     label: "Transaction Date",
      //     type: "CtDtp",
      //     CtrlProps: { value: "", maxLength: 20 },
      //   },
      //   {
      //     id: "vac_remark",
      //     label: "Remark",
      //     type: "CtMultiLineText",
      //     CtrlProps: { value: "", width: 100, maxLength: 1000 },
      //   },
    ],
    // actionList: [
    //   {
    //     name: "Edit",
    //     icon: <Edit />,
    //     link: "RecieptEntry:",
    //     actionType: "AlertResponsive",
    //   },
    //   {
    //     name: "Delete",
    //     icon: <Delete />,
    //     link: "RecieptEntry:",
    //     actionType: "AlertResponsive",
    //     hide:
    //       this.props.userPrivilege.Receipt == "R" ||
    //       this.props.userPrivilege.Receipt == "W",
    //   },
    // ],
    // keyColumn: [
    //   "bint_acid",
    //   "vac_groupname",
    //   "vac_ledgername",
    //   "dec_amount",
    //   "vac_chequeno",
    //   "vac_referenceno",
    //   "dat_transactiondate",
    //   "vac_remark",
    // ],
    formData: {},
    dataLoadStatus: true,
    ARD: null,
    rows: [],
    rowsCount: 0,
    // rowsPerPage: 50,
    rowsPerPage: this.props.rowsPerPage || 50,
    totalPaidAmt: 0,
    bolDisableChkOfTable: false,
    disableReceiptAmt: true,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RA : Payment Mode Table";
    // this.props.setActiveMenu("InvoiceListTable");
    // this.getInfo(this.props.DefaultEntrySettingList, this.props.LedgerNameList, this.props.PaymentLedgerNameList, this.props.PaymentData)
    // this.setSearchColumns();
    // this.props.verifyUserID(() => {
    //     this.getInfo(true);
    // });
    this.setOnComponentEvent(
      // this.props.DefaultEntrySettingList,
      // this.props.PaymentLedgerNameList,
      // this.props.PaymentData,
      this.props.PendingInvoiceList,
      // this.props.txtAmount
    );
    this.getInfo(this.props.PendingInvoiceList);
  }

  componentWillReceiveProps(newProps) {
    // console.log("newProps", newProps);
    if (
      newProps.PendingInvoiceList &&
      newProps.PendingInvoiceList != this.state.PendingInvoiceList
    ) {
      this.setOnComponentEvent(newProps.PendingInvoiceList);

      // this.setState({ DefaultEntrySettingList, LedgerNameList, PaymentLedgerNameList });
    }
    // if (newProps.txtAmount && newProps.txtAmount > 0) {
    //     this.onAmountTextChange(newProps.txtAmount)
    // }
  }
  //#endregion Component

  //#region handle
  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    if (
      Number(rows[handledRowIndex].dec_amount) >
      Number(rows[handledRowIndex].dec_oustandingamount)
    ) {
      this.props.toastErrorMsg(
        "You Can Enter Amount Upto " +
          rows[handledRowIndex].dec_oustandingamount,
      );
    }
    // console.log("this.state.rows", this.state.rows);
    this.setState({ rows, rowsCount: rows.length }, () => {
      // console.log("rows", rows);
      // console.log("colID", colID);
      if (colID === "chk_paymentmode") {
        this.setPaymentModeTableDataForSave(colID === "chk_paymentmode");
      } else if (colID === "dec_amount") {
        let totalPaidAmt = 0,
          checkRows = [],
          rows = this.state.rows.map((row) => {
            // console.log("row", row);
            row.dec_amount === undefined
              ? (row.dec_amount = "")
              : Number(row.dec_amount);
            // console.log("row.dec_amount", row.dec_amount);
            totalPaidAmt += Number(row.dec_amount);
            // console.log("totalPaidAmt usgcusugcsucusc", totalPaidAmt);
            if (Number(row.dec_amount) && Number(row.dec_amount) > 0) {
              checkRows.push(row);
            }

            if (
              row.dec_amount &&
              Number(row.dec_amount) === Number(row.dec_oustandingamount)
            ) {
              return { ...row, chk_paymentmode: true };
            } else {
              return { ...row, chk_paymentmode: false };
            }
          });
        this.setState(
          {
            rows,
            totalPaidAmt,
            checkRows,
          },
          () => {
            this.props.setPaymentDataofReceipt(
              this.state.checkRows,
              this.state.totalPaidAmt,
            );
          },
        );
        // console.log("totatchangepaidamount", totatchangepaidamount);
      } else {
        this.props.setPaymentDataofReceipt(
          this.state.checkRows,
          this.state.totalPaidAmt,
        );
        // this.props.setReceiptAmt();
      }
    });
  };
  //#endregion handle

  //#region function

  setOnComponentEvent = (
    // DefaultEntrySettingList,
    // PaymentLedgerNameList,
    // PaymentData,
    PendingInvoiceList,
    // txtAmount
  ) => {
    // let dec_amount = txtAmount;
    this.setState(
      {
        // DefaultEntrySettingList,
        // rows: newProps.PaymentLedgerNameList,
        // PaymentData,
        // dec_amount,
        PendingInvoiceList,
      },
      () => {
        this.getInfo(
          // DefaultEntrySettingList,
          // PaymentLedgerNameList,
          // PaymentData
          PendingInvoiceList,
        );
      },
    );
  };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (row.dec_amount !== null && row.dec_amount !== undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (dec_amount === Number(this.state.formData.txtAmount)) {
        result = true;
      } else if (dec_amount === 0) {
        this.props.toastErrorMsg("Enter Payment Mode Amount", "txtAmount");
      } else {
        this.props.toastErrorMsg(
          "Receipt Amount must be same as Total of Payment Mode Amount",
          "txtAmount",
        );
      }
    } else {
      result = true;
    }
    return result;
  };

  validateReceiptAmt = () => {
    let result = false;
    if (this.props.txtAmount.length <= 0) {
      this.props.toastErrorMsg("Enter Amount", "txtAmount");
    } else {
      result = true;
    }
    return result;
  };

  SaveInvoice = () => {
    if (this.validateReceiptAmt() === true) {
      let checkRows = [];
      let Recepitamount = this.props.txtAmount;
      let rows = this.state.rows.map((row) => {
        if (Number(Recepitamount) > 0) {
          let dec_amount = 0;
          if (Number(Recepitamount) > Number(row.dec_oustandingamount)) {
            dec_amount = row.dec_oustandingamount;
            row["chk_paymentmode"] = true;
          } else {
            dec_amount = Recepitamount;
            row["chk_paymentmode"] = false;
          }
          row["dec_amount"] = dec_amount;
          // row["chk_paymentmode"] = true;
          // row["enablestatus"] = false;
          Recepitamount -= dec_amount;
          checkRows.push(row);
        }
        row["enablestatus"] = false;
        // console.log('row["enablestatus"]', row["enablestatus"]);
        return row;
      });
      // this.setState({
      //   rows,
      // });
      this.setState(
        {
          // rows,
          totalPaidAmt: this.props.txtAmount,
          checkRows,
        },
        () => {
          // console.log("chekrows", checkRows);
          this.props.setPaymentDataofReceipt(
            this.state.checkRows,
            this.state.totalPaidAmt,
          );
          // this.props.setReceiptAmt(this.state.totalPaidAmt);
        },
      );
    }
  };

  InvoiceUnpaid = () => {
    let disableReceiptAmt = true;
    if (this.props.disableReceiptAmt === true) {
      disableReceiptAmt = false;
    } else {
      disableReceiptAmt = false;
    }
    let rows = this.state.rows.map((row) => {
      row["dec_amount"] = "";
      row["chk_paymentmode"] = false;
      row["enablestatus"] = true;
      // console.log('row["enablestatus"]', row["enablestatus"]);
      return row;
    });
    this.setState(
      {
        rows,
        disableReceiptAmt,
      },
      () => {
        this.props.EnableReceiptAmt(this.state.disableReceiptAmt);
      },
    );
  };

  getInfo = (PendingInvoiceList) => {
    console.log("PendingInvoiceList 379", PendingInvoiceList);

    console.log("vac_ledgername", this.props.vac_ledgername);

    //   // if (this.props.InvoiceData && this.props.InvoiceData.length > 0) {
    //     console.log("faizan true");
    //  . } else {
    //     console.log("sheikh");
    //   // }

    let arrPendingInvoiceList =
      this.props.InvoiceData &&
      this.props.InvoiceData.length > 0 &&
      this.props.ledger.some(
        (row) => row.vac_ledgername === this.props.vac_ledgername,
      )
        ? []
        : PendingInvoiceList;
    // let arrPendingInvoiceList = [];
    if (
      this.props.InvoiceData &&
      this.props.InvoiceData.length > 0 &&
      this.props.ledger.some(
        (row) => row.vac_ledgername === this.props.vac_ledgername,
      )
    ) {
      console.log("PendingInvoiceList 392", PendingInvoiceList);
      console.log("arrPendingInvoiceList 393", arrPendingInvoiceList);
      arrPendingInvoiceList = [];
      this.props.InvoiceData.map((row) => {
        arrPendingInvoiceList.push({
          ...row,
          chk_paymentmode:
            Number(row.dec_paidamount) == Number(row.dec_oustandingamount)
              ? true
              : false,
          dec_amount: row.dec_paidamount,
          enablestatus: true,
        });
      });
      console.log("arrPendingInvoiceList 408", arrPendingInvoiceList);
    } else {
      // console.log("else arrPendingInvoiceList", arrPendingInvoiceList);
      console.log("arrPendingInvoiceList 410", arrPendingInvoiceList);

      arrPendingInvoiceList = arrPendingInvoiceList.map((row) => {
        return { ...row, enablestatus: true };
      });
    }
    console.log("arrPendingInvoiceList", arrPendingInvoiceList);

    this.setState(
      {
        rows: arrPendingInvoiceList,
        rowsCount: arrPendingInvoiceList.length,
      },
      () => {
        console.log("rows", this.state.rows);
      },
    );
  };

  onEditEntry = (PaymentData, rows, amtSetInAnyRowCount) => {
    /**Set rows based on two different arrays that contains different part of rows information only EditSrNo found > 0*/
    if (
      this.props.Edit_SrNo &&
      Number(this.props.Edit_SrNo) > 0 &&
      Number(amtSetInAnyRowCount) === Number(0)
    ) {
      let rowsCount = 0;
      if (PaymentData && PaymentData.length > 0) {
        PaymentData.map((odd) => {
          let isFound = 0;
          rows.map((rod) => {
            if (rod.vac_ledgername === odd.vac_ledgername) {
              // rod.vac_value = odd.vac_value;
              rod.dec_amount = odd.dec_amount;
              rod.vac_chequeno = odd.vac_chequeno;
              rod.vac_referenceno = odd.vac_referenceno;
              rod.dat_transactiondate = odd.dat_transactiondate;
              rod.vac_remark = odd.vac_remark;
              // rod.vac_groupname = odd.vac_groupname;
              isFound++;
            }
          });
          if (isFound === 0) {
            rows.push({
              vac_ledgername: odd.vac_ledgername,
              dec_amount: odd.dec_amount,
              vac_chequeno: odd.vac_chequeno,
              vac_referenceno: odd.vac_referenceno,
              dat_transactiondate: odd.dat_transactiondate,
              vac_remark: odd.vac_remark,
              // vac_groupname: odd.vac_groupname,
              // bint_displayorderno: rowsPaymentMode.length + 1,
            });
          }
        });
        rowsCount = rows.length;
      }
      let amtCount = 0,
        amtIndex = 0;
      rows = rows.map((row, index) => {
        if (Number(row.dec_amount) > 0) {
          amtIndex = index;
          amtCount++;
        }
        return row;
      });
      if (amtCount > 0) {
        rows = rows.map((row, index) => {
          row.chk_paymentmode = false;
          return row;
        });
        if (amtCount === 1) rows[amtIndex].chk_paymentmode = true;
      }
      this.setState(
        {
          rows,
          rowsCount,
        },
        () => {
          // document.getElementById("cmbLedgerGroup").focus();
        },
      );
    }
  };

  setPaymentModeTableDataForSave = (isCalledByChkClicked) => {
    if (this.state.rows.length > 0) {
      let amtSetInAnyRowCount = 0,
        amtSetRowIndex = [],
        totalPaidAmt = 0,
        checkRows = [],
        alreadyPaidAmt = 0,
        rows = this.state.rows.map((row, index) => {
          if (Number(row.dec_amount) > 0 || Number(row.dec_amount) < 0) {
            amtSetInAnyRowCount++;
            amtSetRowIndex.push(index);
            alreadyPaidAmt += Number(row.dec_amount);
          }
          return row;
        });
      if (amtSetInAnyRowCount <= 1 || isCalledByChkClicked) {
        rows = this.state.rows.map((row) => {
          if (row.chk_paymentmode === true) {
            const checkrowpushdata = {
              ...row,
              dec_amount: Number(row.dec_oustandingamount),
            };
            checkRows.push(checkrowpushdata);
            totalPaidAmt += Number(row.dec_oustandingamount);
            return { ...row, dec_amount: Number(row.dec_oustandingamount) };
          } else if (
            row.chk_paymentmode === true &&
            (row.dec_amount ? row.dec_amount.length > 0 : "")
          ) {
            checkRows.push(row);
            totalPaidAmt += Number(row.dec_amount);
            return { ...row, dec_amount: row.dec_amount };
          } else if (
            row.chk_paymentmode === false &&
            Number(row.dec_amount) === Number(row.dec_oustandingamount)
          ) {
            // console.log("in untick whene data are same");
            checkRows.push(row);
            totalPaidAmt += 0;
            return { ...row, dec_amount: "" };
          } else if (row.chk_paymentmode === false) {
            checkRows.push(row);

            totalPaidAmt +=
              row.dec_amount === undefined ? 0 : Number(row.dec_amount);
            return { ...row, dec_amount: row.dec_amount ? row.dec_amount : "" };
          } else {
            return { ...row, dec_amount: "" };
          }
        });
      } else {
        amtSetRowIndex.forEach((idx) => {
          rows[idx].chk_paymentmode = false;
        });
      }
      this.setState(
        {
          rows,
          totalPaidAmt,
          checkRows,
        },
        () => {
          // console.log("this.state.totalPaidAmt", this.state.totalPaidAmt);
          this.props.setPaymentDataofReceipt(
            this.state.checkRows,
            this.state.totalPaidAmt,
          );
          // this.props.setReceiptAmt(this.state.totalPaidAmt);
        },
      );
    }
  };

  onAmountTextChange = (txtAmount) => {
    let rows = this.state.rows.map((row, index) => {
      if (row.chk_paymentmode == true) {
        row.dec_amount = txtAmount;
      }
      return row;
    });
    this.setState({ rows });
  };
  //#endregion

  render() {
    let rows = this.state.rows;
    let rowsCount = this.state.rowsCount;
    let disableBtn = this.props.Edit_SrNo ? "none" : "block";
    return (
      <form>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
        >
          <Grid item marginBottom={2} display={disableBtn}>
            <CtBtn
              label={this.props.btnpaid}
              onClick={this.SaveInvoice}
              variant="outlined"
            />
          </Grid>
          <Grid item marginBottom={2}>
            <CtBtn
              label={this.props.btnunpaid}
              onClick={this.InvoiceUnpaid}
              variant="outlined"
            />
          </Grid>
        </Grid>
        <TableList
          columns={this.props.columns}
          counter={this.state.counter}
          onKeyDown={this.props.onKeyDown}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          //   handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          //   keyColumn={this.state.keyColumn}
          //   handleOnSearchChange={this.handleOnSearchChange}
          //   searchColumns={this.state.searchColumns}
          //   searchData={this.state.searchData}
          // provideSearch={true}
          //   handleOnNewEntryClick={this.handleOnNewEntryClick}
          handleOnRowDataChange={this.handleOnRowDataChange}
          // toolTipNewEntry='New Product Entry'
        />
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(InvoiceListTable))));
